module.exports = __webpack_public_path__ + "static/sculpture-love-logo2-d3e5a5edf3dec60ec13797a0d4b23e14.png";